<script>
import { mapGetters } from "vuex";

import UploadTracker from "@/pages/deepfake/components/upload/UploadTracker.vue";

export default {
  name: "SnsIsland",
  components: {
    UploadTracker,
  },
  props: {
    position: {
      type: String,
      default: "bottom-right",
    },
  },
  computed: {
    ...mapGetters({
      uploadState: "upload/uploadState",
    }),
    positionClasses() {
      const positions = {
        "bottom-right": "bottom-4 right-4",
        "bottom-left": "bottom-4 left-4",
        "top-right": "top-4 right-4",
        "top-left": "top-4 left-4",
      };

      return positions[this.position];
    },
    shouldShow() {
      return this.uploadState.isUploading || this.$slots.default;
    },
  },
};
</script>

<template>
  <Transition name="slide-fade">
    <div v-if="shouldShow" :class="['sns-island', positionClasses]">
      <UploadTracker v-if="uploadState.isUploading" />
      <slot v-else />
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
.sns-island {
  @apply fixed z-50 bg-base-100 border border-accent rounded shadow-lg;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>
